import { useState } from 'react';
import {
  useListPayors,
  useListProvidersBySite,
  useListRemittanceBySite,
  useListReportsByUser,
  useListSubmissionsBySite,
} from 'api/resource';
import { useProviderAllSites } from 'hooks/useProviderAllSites';
import { MRT_ColumnFiltersState, MRT_SortingState } from 'mantine-react-table';
import { useCurrentSiteStore } from 'store/SiteStore';
import { useCurrentUserStore } from 'store/UserStore';

export const useProviderManagementData = () => {
  const site = useCurrentSiteStore();
  const { id: userID } = useCurrentUserStore();
  const {
    hasSiteScope,
    isAllSites,
    providersResult: providersByUserResult,
    siteID,
    sites,
  } = useProviderAllSites();
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
    globalFilter: '',
    columnFilters: [] as MRT_ColumnFiltersState,
    sorting: [] as MRT_SortingState,
  });

  const reportsResult = useListReportsByUser({
    userID,
    siteID,
    page: pagination.pageIndex,
    pageSize: pagination.pageSize,
    filters: pagination.columnFilters,
    globalFilter: pagination.globalFilter,
    sorting: pagination.sorting,
    enabled: hasSiteScope,
  });
  const providersBySiteResult = useListProvidersBySite({
    siteID: Array.isArray(siteID) ? undefined : siteID,
  });
  const providersResult = isAllSites
    ? providersByUserResult
    : providersBySiteResult;
  const submissionsResult = useListSubmissionsBySite({ siteID });
  const remittanceResult = useListRemittanceBySite({ siteID });
  const payorsResult = useListPayors();
  const isLoading = [
    reportsResult.isLoading,
    providersResult.isLoading,
    submissionsResult.isLoading,
    remittanceResult.isLoading,
    payorsResult.isLoading,
  ].some((loading) => loading);
  const isError = [
    reportsResult.isError,
    providersResult.isError,
    submissionsResult.isError,
    remittanceResult.isError,
    payorsResult.isError,
  ].some((error) => error);
  const isFetching = [
    reportsResult.isFetching,
    providersResult.isFetching,
    submissionsResult.isFetching,
    remittanceResult.isFetching,
    payorsResult.isFetching,
  ].some((fetching) => fetching);
  const errorMessage = [
    reportsResult.error?.message,
    providersResult.error?.message,
    submissionsResult.error?.message,
    remittanceResult.error?.message,
    payorsResult.error?.message,
  ].find((message) => message);
  return {
    reports: reportsResult.data?.data || [],
    sites: isAllSites ? sites : [site],
    providers: providersResult.data || [],
    submissions: submissionsResult.data || [],
    payors: payorsResult.data || [],
    remittances: remittanceResult.data || [],
    totalReports: reportsResult.data?.total || 0,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    refetchReports: reportsResult.refetch,
    pagination,
    setPagination,
  };
};
